import React from "react";

const PatternContext = React.createContext(null);

export default PatternContext;
